import Resource from '../../../api/resource';

export class PertaminaService extends Resource {
  constructor() {
    super('', '/api', 'api-asman-telkom', null);
  }

  /**
   * @param {Object} param
   * @param {string} param.name
   * @param {'SPBU' | 'ANALYSIS' | 'NEW'} param.type
   * @param {number} param.id_province
   * @param {number} param.id_city
   * @param {number} param.id_district
   * @param {number} param.id_village
   * @returns {Promise<Object>}
   */
  getListAsset(param) {
    const filterStringfy = JSON.stringify({
      red_ocean: param?.red_ocean.length ? param?.red_ocean : null,
      blue_ocean: param?.blue_ocean.length ? param?.blue_ocean : null,
    });
    const forgeBody = {
      name: param?.name ? param?.name : null,
      id_province: param?.id_province ? param?.id_province : null,
      id_city: param?.id_city ? param?.id_city : null,
      id_district: param?.id_district ? param?.id_district : null,
      id_village: param?.id_village ? param?.id_village : null,
      type: param.type ? param.type : null,
      filter:
        param?.red_ocean.length || param?.blue_ocean.length
          ? filterStringfy
          : null,
    };
    this.setAdditionUri('assets');
    return this.list(forgeBody);
  }

  /**
   * @param {Object} param
   * @param {string} param.site_id
   * @returns {Promise<Object>}
   */
  getDetailAsset(param) {
    this.setAdditionUri('asset/detail');
    return this.get(null, param);
  }

  /**
   * @param {Object} param
   * @param {string} param.name
   * @param {number} param.id_province
   * @param {number} param.id_city
   * @param {number} param.id_district
   * @param {number} param.id_village
   * @param {function} cb
   * @returns {Promise<Object>}
   */
  downloadAssetList(param, cb) {
    const filterStringfy = JSON.stringify({
      red_ocean: param?.red_ocean.length ? param?.red_ocean : null,
      blue_ocean: param?.blue_ocean.length ? param?.blue_ocean : null,
    });
    const forgeBody = {
      name: param?.name ? param?.name : null,
      province: param?.province ? param?.province : null,
      city: param?.city ? param?.city : null,
      district: param?.district ? param?.district : null,
      village: param?.village ? param?.village : null,
      type: param.type ? param.type : null,
      filter:
        param?.red_ocean.length || param?.blue_ocean.length
          ? filterStringfy
          : null,
    };
    this.setAdditionUri('download');
    return this.stream(forgeBody, cb);
  }

  /**
   * @param {string} id
   */
  deleteAsset(id) {
    this.setAdditionUri('onthefly/delete');
    return this.delete(id);
  }
  /**
   *
   * @param {object} param
   * @param {string} param.site_id
   * @param {string} param.name
   * @param {string} param.longitude
   * @param {string} param.latitude
   * @param {string} param.address
   * @param {string} param.image_base64
   */
  createUpdateAsset(param) {
    this.setAdditionUri('onthefly');
    return this.create(param);
  }

  /**
   * @param {object} params
   * @param {string} params.area_ruko_id
   * @param {boolean} params.is_history
   * @param {string} params.period
   */
  getRukoList(params) {
    this.setAdditionUri('ruko');
    return this.get(null, params);
  }

  /**
   * @param {object} params
   * @param {string} params.area_tenant_id
   * @param {boolean} params.is_history
   * @param {string} params.period
   */
  getTenantList(params) {
    this.setAdditionUri('tenant');
    return this.get(null, params);
  }

  /**
   * @param {object} params
   * @param {string} params.area_poi_id
   * @param {boolean} params.is_history
   * @param {string} params.period
   */
  getPOIList(params) {
    this.setAdditionUri('poi');
    return this.get(null, params);
  }
  getStatusAsset() {
    this.setAdditionUri('assets');
    return this.list({ limit: 20 });
  }
  getNewTenantList() {
    this.setAdditionUri('tenants/new');
    return this.list();
  }
  /**
   * @param {object} payload
   * @param {string} payload.area_id
   * @param {string} payload.category_id
   * @param {string} payload.longitude
   * @param {string} payload.latitude
   * @param {string[]} payload.tenant_names
   */
  cerateNewTenants(payload) {
    this.setAdditionUri('tenants/bulk');
    return this.create(payload);
  }
  removeNewTenant(id) {
    this.setAdditionUri('tenants/delete');
    return this.delete(id);
  }
  doBulkDownloadResultXls(param) {
    const filterStringfy = JSON.stringify({
      red_ocean: param?.red_ocean.length ? param?.red_ocean : null,
      blue_ocean: param?.blue_ocean.length ? param?.blue_ocean : null,
    });
    const forgeBody = {
      name: param?.name ? param?.name : null,
      province: param?.province ? param?.province : null,
      city: param?.city ? param?.city : null,
      district: param?.district ? param?.district : null,
      village: param?.village ? param?.village : null,
      type: param.type ? param.type : null,
      filter:
        param?.red_ocean.length || param?.blue_ocean.length
          ? filterStringfy
          : null,
    };
    this.setAdditionUri('download/bulk');
    return this.get(null, forgeBody);
  }
  /**
   *
   * @param {string} param
   */
  getListHistory(param) {
    const forgeParams = {
      site_id: param ? param : null,
    };
    this.setAdditionUri('asset/histories');
    return this.list(forgeParams);
  }

  doBulkDownloadPDF(param) {
    const forgeBody = {
      name: param?.name ? param?.name : null,
      province: param?.province ? param?.province : null,
      city: param?.city ? param?.city : null,
      district: param?.district ? param?.district : null,
      village: param?.village ? param?.village : null,
    };
    this.setAdditionUri('download-pdf');
    return this.get(null, forgeBody);
  }
}
